import React, { useState, ChangeEvent, DragEvent } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';

interface CSVUploadBoxProps {
  onFileUpload: (file: File | null) => void;
}

const CSVUploadBox: React.FC<CSVUploadBoxProps> = ({ onFileUpload }) => {
  const [file, setFile] = useState<File | null>(null);
  const [dragActive, setDragActive] = useState<boolean>(false);

  const handleUpload = (uploadedFile: File) => {
    if (uploadedFile && uploadedFile.type === 'text/csv') {
      setFile(uploadedFile);
      onFileUpload(uploadedFile);
    } else {
      alert('Only .csv files are allowed.');
    }
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files?.[0]) {
      handleUpload(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      handleUpload(e.target.files[0]);
    }
  };

  const handleClear = () => {
    setFile(null);
    onFileUpload(null);
  };

  return (
    <Box
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onDragEnter={() => setDragActive(true)}
      onDragLeave={() => setDragActive(false)}
      sx={{
        border: '2px dashed #ccc',
        borderRadius: 2,
        padding: '32px 16px',
        textAlign: 'center',
        backgroundColor: dragActive ? '#f9f9f9' : '#fff',
        transition: '0.2s',
        position: 'relative',
      }}
    >
      {!file ? (
        <>
          <label htmlFor="csv-upload" style={{ cursor: 'pointer' }}>
            <CloudUploadIcon sx={{ fontSize: 40, color: '#aaa' }} />
            <Typography fontWeight={500} mt={1}>
              Upload dependent fields <strong>.csv</strong> file
            </Typography>
            <input
              id="csv-upload"
              type="file"
              accept=".csv"
              onChange={handleChange}
              style={{ display: 'none' }}
            />
          </label>
        </>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <Typography>{file.name}</Typography>
          <IconButton size="small" onClick={handleClear}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      <Box mt={3} display="flex" justifyContent="center" gap={2}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{ borderColor: '#bb86fc', color: '#bb86fc' }}
        >
          <Link style={{ color: '#bb86fc' }} to="/Dependent-dropdown-list.csv" target="_blank" download>
            Download sample csv
          </Link>
        </Button>
      </Box>
    </Box>
  );
};

export default CSVUploadBox;
